import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["existingContainer", "inputContainer", "secretInput", "toggleButton", "eyeIcon"]

  changeSecret(event) {
    event.preventDefault()
    this.edit()
  }

  cancel(event) {
    event.preventDefault()
    this.reset()
  }

  // Switch to the editable input so a new secret must be entered. Safe to call
  // from other controllers (e.g. when a provider changes and the stored secret
  // no longer applies).
  edit() {
    // Hide the existing container and show the input
    if (this.hasExistingContainerTarget) {
      this.existingContainerTarget.style.display = 'none'
    }

    // Show the input container and enable the input so it gets submitted
    this.inputContainerTarget.style.display = 'block'

    if (this.hasSecretInputTarget) {
      this.secretInputTarget.disabled = false
      this.secretInputTarget.focus()
    }
  }

  // Return to the masked "secret is set" state, discarding any typed value.
  // No-op when there is no stored secret to fall back to.
  reset() {
    if (!this.hasExistingContainerTarget) return

    // Hide the input container and show the existing container
    this.inputContainerTarget.style.display = 'none'
    this.existingContainerTarget.style.display = 'block'

    // Disable the input and clear any typed value
    if (this.hasSecretInputTarget) {
      this.secretInputTarget.disabled = true
      this.secretInputTarget.value = ''
      this.secretInputTarget.type = 'password' // Reset to password type if it was toggled
    }

    // Reset the eye icon to default state
    if (this.hasEyeIconTarget) {
      this.eyeIconTarget.classList.remove('fa-eye-slash')
      this.eyeIconTarget.classList.add('fa-eye')
    }
  }

  toggleVisibility(event) {
    event.preventDefault()

    if (!this.hasSecretInputTarget) return

    const input = this.secretInputTarget
    const icon = this.eyeIconTarget

    if (input.type === 'password') {
      input.type = 'text'
      icon.classList.remove('fa-eye')
      icon.classList.add('fa-eye-slash')
    } else {
      input.type = 'password'
      icon.classList.remove('fa-eye-slash')
      icon.classList.add('fa-eye')
    }
  }
}
